var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn && _vm.emailConfirmed)?_c('div',{staticClass:"p-1 mt-3"},[_c('blue-background',{attrs:{"height":500}}),_c('Home',{staticClass:"mt-2"})],1):_c('HomeSecond')}
var staticRenderFns = []

export { render, staticRenderFns }